import ACTIONS from '../actionTypes/application'

const initialState = {
	application: null,
	isFetchingCurrentApp: false,
	isCreatingApp: false,
	applicationList: [],
	isFetchingAppList: false,
	errorFetchingAppList: false,
	isUpdatingApp: false,
	errorUpdatingApp: false,
	deleteAppStatus: {
		isDeletingApp: false,
		hasError: false,
		error: null
	}
}

const application = (state = initialState, action) => {
	switch (action.type) {
		// createApplication
		case ACTIONS.START_CREATE_APP:
			return {
				...state,
				isCreatingApp: true,
			}
		case ACTIONS.CREATE_APP_SUCCESS:
			return {
				...state,
				isCreatingApp: false,
				application: action.payload,
			}
		case ACTIONS.CREATE_APP_FAILED:
			return {
				...state,
				isCreatingApp: false,
				application: null,
			}

		// getApplicationList
		case ACTIONS.START_GET_APP_LIST:
			return {
				...state,
				isFetchingAppList: true,
			}
		case ACTIONS.GET_APP_LIST_SUCCESS:
			return {
				...state,
				isFetchingAppList: false,
				errorFetchingAppList: false,
				applicationList: action.payload,
			}
		case ACTIONS.GET_APP_LIST_FAILED:
			return {
				...state,
				isFetchingAppList: false,
				errorFetchingAppList: true,
				applicationList: null,
			}

		// getApplicationById
		case ACTIONS.START_GET_APP_BY_ID:
			return {
				...state,
				isFetchingCurrentApp: true

			}
		case ACTIONS.GET_APP_BY_ID_SUCCESS:
			return {
				...state,
				isFetchingCurrentApp: false,
				application: action.payload,
			}
		case ACTIONS.GET_APP_BY_ID_FAILED:
			return {
				...state,
				isFetchingCurrentApp: false,
				application: null,
			}

		// updateApplication
		case ACTIONS.START_UPDATE_APP:
			return {
				...state,
				isUpdatingApp: true
			}
		case ACTIONS.UPDATE_APP_SUCCESS:
			return {
				...state,
				isUpdatingApp: false,
				errorUpdatingApp: false,
				application: action.payload,
			}
		case ACTIONS.UPDATE_APP_FAILED:
			return {
				...state,
				isUpdatingApp: false,
				errorUpdatingApp: true
			}

		// delete Application
		case ACTIONS.START_DELETE_APP:
			return {
				...state,
				deleteAppStatus: {
					isDeletingApp: true,
					hasError: false,
					error: null
				}
			}
		case ACTIONS.DELETE_APP_SUCCESS:
			return {
				...state,
				deleteAppStatus: {
					isDeletingApp: false,
					hasError: false,
					error: null
				},
			}
		case ACTIONS.DELETE_APP_FAILED:
			return {
				...state,
				deleteAppStatus: {
					isDeletingApp: false,
					hasError: true,
					error: action.error
				}
			}
		// default
		default:
			return state
	}
}

export default application